// extracted by mini-css-extract-plugin
export default {"root":"nFuTNMcy2a","root_fill":"Zs0BpT3rjx","lasso":"KQQSbDONrA"};